//
//
//
//
//
//
//
//
//
//
//

export default {
    mounted() {
    },
    props: {
        item: Object
    },
    methods: {
        goDetail() {
            const {usage, building_id} = this.item
            wx.navigateTo({
                url: usage === '商业' ? `/building/business?building_id=${building_id}` : `/building?building_id=${building_id}`
            })
        }
    }
}
